import { AudienceDefinition } from '@airgrid/edgekit';
import { FeaturesResponse } from 'ts-types';
import { AUDIENCES_URL, FEATURES_URL, ANALYTICS_ERROR_URL } from '../constants';
import { getCleanUrl } from './url';
import { makeGetRequest, makePostRequest } from './http';

export declare const DISABLE_AUDIENCES: boolean;
export declare const DISABLE_FEATURES: boolean;

const getFeatures = async (
  apiKey: string,
  accountId: string,
  publisherId: string,
  loadId: string
): Promise<FeaturesResponse | null> => {
  if (DISABLE_FEATURES) return null;

  const url = getCleanUrl();
  const features = await makeGetRequest<FeaturesResponse>(
    `${FEATURES_URL}?accId=${accountId}&pubId=${publisherId}&url=${encodeURIComponent(
      url
    )}`,
    apiKey,
    loadId
  );
  return features;
};

const getAudiences = async (
  apiKey: string,
  accountId: string,
  loadId: string
): Promise<AudienceDefinition[]> => {
  if (DISABLE_AUDIENCES) return [];

  const audienceResponse = await makeGetRequest<AudienceDefinition[]>(
    `${AUDIENCES_URL}?accountId=${accountId}`,
    apiKey,
    loadId
  );

  if (!audienceResponse) return [];
  return audienceResponse;
};

export const getFeaturesAndAudiences = async (
  apiKey: string,
  accountId: string,
  publisherId: string,
  loadId: string
) => {
  const [featuresResponse, audienceDefinitions] = await Promise.all([
    getFeatures(apiKey, accountId, publisherId, loadId),
    getAudiences(apiKey, accountId, loadId),
  ]);
  return { featuresResponse, audienceDefinitions };
};

export const logError = async (
  loadId: string,
  apiKey: string,
  error: { name: string; message: string; stack: string }
): Promise<void> => {
  await makePostRequest(
    ANALYTICS_ERROR_URL,
    JSON.stringify({
      name: error.name,
      message: error.message,
      stack: error.stack,
      url: getCleanUrl(),
    }),
    apiKey,
    loadId
  );
};
